import { render, staticRenderFns } from "./jzuni_order.vue?vue&type=template&id=4a784a91&scoped=true&"
import script from "./jzuni_order.vue?vue&type=script&lang=js&"
export * from "./jzuni_order.vue?vue&type=script&lang=js&"
import style0 from "./jzuni_order.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./jzuni_order.vue?vue&type=style&index=1&id=4a784a91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a784a91",
  null
  
)

export default component.exports